<template>
  <v-container>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Editar Estabelecimento</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="goBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </v-toolbar>

    <v-form ref="editForm" v-model="formValid">
      <v-img 
          :src="getImageSrc()" 
          :width="isMobile ? '100%' : '30%'" 
          class="grey lighten-2" 
          aspect-ratio="1" 
          contain
        >
          <v-container fill-height fluid  pb-4>
            <!-- Botões para adicionar ou alterar a imagem -->
            <v-layout row align-center v-if="!imageUrl" pb-4>
              <v-flex class="text-xs-center">
                <v-btn class="sp-transparent" dark @click="pickFile">
                  Sua Logomarca aqui
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-else align-center >
              <v-flex class="text-xs-center" :style="{width : '150px',}">
                <v-btn block class="sp-transparent" dark @click="pickFile" pb-4 >
                  Alterar imagem
                </v-btn>
                <v-btn block class="sp-transparent-red" dark @click="clearImage">
                  Remover
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <span class="body-1 grey--text lighten-1">
          Imagem quadrada. Formato JPEG ou JPG. Máx: 500KB
        </span>
        </v-img>      
      
        <v-text-field
        v-model="form.restaurantname"
        label="Nome do Estabelecimento"
        :rules="[rules.required]"
        required
        ></v-text-field>
      <v-text-field
        v-model="form.phone"
        label="Telefone"
        :rules="[rules.required]"
        required
      ></v-text-field>
      <v-text-field
        v-model="form.email"
        label="E-mail"
        :rules="[rules.required]"
        required
      ></v-text-field>                                  
     

      <v-select
        v-model="form.webapp_color_0"
        :items="colorOptions"
        label="Cor Principal"
        :rules="[rules.required]"        
        item-value="value"
        required
        :style="{ color: colorOptions.value }"
        
      >
      <!-- Personaliza a exibição dos itens -->
      <template #selection="{ item }">
        <v-layout align-center>
          <div
            class="color-box"
            :style="{ backgroundColor: item || '#fff', width: '20px', height: '20px', borderRadius: '50%' }"
          ></div>
          <span class="ml-2 " :style="{marginTop : '10px'}">
            {{ item.name }}
          </span>
        </v-layout>
      </template>
       
        <template #item="data">
          <v-layout align-center>
            <div
              class="color-box"
              :style="{ backgroundColor: data.item.value, width: '20px', height: '20px', borderRadius: '50%' }"
            ></div>
            <span class="ml-2">{{ data.item.name }}</span>
          </v-layout>
        </template>
    </v-select>
    </v-form>

    <v-card-actions>
      <v-btn color="primary" :disabled="!formValid" @click="saveChanges">
        Salvar
      </v-btn>
      <v-btn text @click="goBack">Cancelar</v-btn>
    </v-card-actions>
  </v-container>


</template>

<script>
import { mapState } from "vuex";

import colors from "vuetify/lib/util/colors";
export default {
  name: "SpEditRestaurant",

  data() {
    return {
      form: {
        phone: "",
        email: "",        
        number: "",                                                
        photo: "",        
        tag_photo: "",
        webapp_color_0: "", 
      },
      colorOptions: [
      { name: "Red Lighten-5", value: "#FFEBEE" },
      { name: "Red Lighten-4", value: "#FFCDD2" },
      { name: "Red Lighten-3", value: "#EF9A9A" },
      { name: "Red Lighten-2", value: "#E57373" },
      { name: "Red Lighten-1", value: "#EF5350" },
      { name: "Red Darken-1", value: "#E53935" },
      { name: "Red Darken-2", value: "#D32F2F" },
      { name: "Red Darken-3", value: "#C62828" },
      { name: "Red Darken-4", value: "#B71C1C" },
      { name: "Red Accent-1", value: "#FF8A80" },
      { name: "Red Accent-2", value: "#FF5252" },
      { name: "Red Accent-3", value: "#FF1744" },
      { name: "Red Accent-4", value: "#D50000" },
      { name: "Pink Lighten-5", value: "#FCE4EC" },
      { name: "Pink Lighten-4", value: "#F8BBD0" },
      { name: "Pink Lighten-3", value: "#F48FB1" },
      { name: "Pink Lighten-2", value: "#F06292" },
      { name: "Pink Lighten-1", value: "#EC407A" },
      { name: "Pink Darken-1", value: "#D81B60" },
      { name: "Pink Darken-2", value: "#C2185B" },
      { name: "Pink Darken-3", value: "#AD1457" },
      { name: "Pink Darken-4", value: "#880E4F" },
      { name: "Pink Accent-1", value: "#FF80AB" },
      { name: "Pink Accent-2", value: "#FF4081" },
      { name: "Pink Accent-3", value: "#F50057" },
      { name: "Pink Accent-4", value: "#C51162" },
      { name: "Purple Lighten-5", value: "#F3E5F5" },
      { name: "Purple Lighten-4", value: "#E1BEE7" },
      { name: "Purple Lighten-3", value: "#CE93D8" },
      { name: "Purple Lighten-2", value: "#BA68C8" },
      { name: "Purple Lighten-1", value: "#AB47BC" },
      { name: "Purple Darken-1", value: "#8E24AA" },
      { name: "Purple Darken-2", value: "#7B1FA2" },
      { name: "Purple Darken-3", value: "#6A1B9A" },
      { name: "Purple Darken-4", value: "#4A148C" },
      { name: "Purple Accent-1", value: "#EA80FC" },
      { name: "Purple Accent-2", value: "#E040FB" },
      { name: "Purple Accent-3", value: "#D500F9" },
      { name: "Purple Accent-4", value: "#AA00FF" },
      { name: "Deep Purple Lighten-5", value: "#EDE7F6" },
      { name: "Deep Purple Lighten-4", value: "#D1C4E9" },
      { name: "Deep Purple Lighten-3", value: "#B39DDB" },
      { name: "Deep Purple Lighten-2", value: "#9575CD" },
      { name: "Deep Purple Lighten-1", value: "#7E57C2" },
      { name: "Deep Purple Darken-1", value: "#5E35B1" },
      { name: "Deep Purple Darken-2", value: "#512DA8" },
      { name: "Deep Purple Darken-3", value: "#4527A0" },
      { name: "Deep Purple Darken-4", value: "#311B92" },
      { name: "Deep Purple Accent-1", value: "#B388FF" },
      { name: "Deep Purple Accent-2", value: "#7C4DFF" },
      { name: "Deep Purple Accent-3", value: "#651FFF" },
      { name: "Deep Purple Accent-4", value: "#6200EA" },
      { name: "Indigo Lighten-5", value: "#E8EAF6" },
      { name: "Indigo Lighten-4", value: "#C5CAE9" },
      { name: "Indigo Lighten-3", value: "#9FA8DA" },
      { name: "Indigo Lighten-2", value: "#7986CB" },
      { name: "Indigo Lighten-1", value: "#5C6BC0" },
      { name: "Indigo Darken-1", value: "#3949AB" },
      { name: "Indigo Darken-2", value: "#303F9F" },
      { name: "Indigo Darken-3", value: "#283593" },
      { name: "Indigo Darken-4", value: "#1A237E" },
      { name: "Indigo Accent-1", value: "#8C9EFF" },
      { name: "Indigo Accent-2", value: "#536DFE" },
      { name: "Indigo Accent-3", value: "#3D5AFE" },
      { name: "Indigo Accent-4", value: "#304FFE" },
      { name: "Blue Lighten-5", value: "#E3F2FD" },
      { name: "Blue Lighten-4", value: "#BBDEFB" },
      { name: "Blue Lighten-3", value: "#90CAF9" },
      { name: "Blue Lighten-2", value: "#64B5F6" },
      { name: "Blue Lighten-1", value: "#42A5F5" },
      { name: "Blue Darken-1", value: "#1E88E5" },
      { name: "Blue Darken-2", value: "#1976D2" },
      { name: "Blue Darken-3", value: "#1565C0" },
      { name: "Blue Darken-4", value: "#0D47A1" },
      { name: "Blue Accent-1", value: "#82B1FF" },
      { name: "Blue Accent-2", value: "#448AFF" },
      { name: "Blue Accent-3", value: "#2979FF" },
      { name: "Blue Accent-4", value: "#2962FF" },
      { name: "Light Blue Lighten-5", value: "#E1F5FE" },
      { name: "Light Blue Lighten-4", value: "#B3E5FC" },
      { name: "Light Blue Lighten-3", value: "#81D4FA" },
      { name: "Light Blue Lighten-2", value: "#4FC3F7" },
      { name: "Light Blue Lighten-1", value: "#29B6F6" },
      { name: "Light Blue Darken-1", value: "#039BE5" },
      { name: "Light Blue Darken-2", value: "#0288D1" },
      { name: "Light Blue Darken-3", value: "#0277BD" },
      { name: "Light Blue Darken-4", value: "#01579B" },
      { name: "Light Blue Accent-1", value: "#80D8FF" },
      { name: "Light Blue Accent-2", value: "#40C4FF" },
      { name: "Light Blue Accent-3", value: "#00B0FF" },
      { name: "Light Blue Accent-4", value: "#0091EA" },
      { name: "Cyan Lighten-5", value: "#E0F7FA" },
      { name: "Cyan Lighten-4", value: "#B2EBF2" },
      { name: "Cyan Lighten-3", value: "#80DEEA" },
      { name: "Cyan Lighten-2", value: "#4DD0E1" },
      { name: "Cyan Lighten-1", value: "#26C6DA" },
      { name: "Cyan Darken-1", value: "#00ACC1" },
      { name: "Cyan Darken-2", value: "#0097A7" },
      { name: "Cyan Darken-3", value: "#00838F" },
      { name: "Cyan Darken-4", value: "#006064" },
      { name: "Cyan Accent-1", value: "#84FFFF" },
      { name: "Cyan Accent-2", value: "#18FFFF" },
      { name: "Cyan Accent-3", value: "#00E5FF" },
      { name: "Cyan Accent-4", value: "#00B8D4" },
      { name: "Teal Lighten-5", value: "#E0F2F1" },
      { name: "Teal Lighten-4", value: "#B2DFDB" },
      { name: "Teal Lighten-3", value: "#80CBC4" },
      { name: "Teal Lighten-2", value: "#4DB6AC" },
      { name: "Teal Lighten-1", value: "#26A69A" },
      { name: "Teal Darken-1", value: "#00897B" },
      { name: "Teal Darken-2", value: "#00796B" },
      { name: "Teal Darken-3", value: "#00695C" },
      { name: "Teal Darken-4", value: "#004D40" },
      { name: "Teal Accent-1", value: "#A7FFEB" },
      { name: "Teal Accent-2", value: "#64FFDA" },
      { name: "Teal Accent-3", value: "#1DE9B6" },
      { name: "Teal Accent-4", value: "#00BFA5" },
      { name: "Green Lighten-5", value: "#E8F5E9" },
      { name: "Green Lighten-4", value: "#C8E6C9" },
      { name: "Green Lighten-3", value: "#A5D6A7" },
      { name: "Green Lighten-2", value: "#81C784" },
      { name: "Green Lighten-1", value: "#66BB6A" },
      { name: "Green Darken-1", value: "#43A047" },
      { name: "Green Darken-2", value: "#388E3C" },
      { name: "Green Darken-3", value: "#2E7D32" },
      { name: "Green Darken-4", value: "#1B5E20" },
      { name: "Green Accent-1", value: "#B9F6CA" },
      { name: "Green Accent-2", value: "#69F0AE" },
      { name: "Green Accent-3", value: "#00E676" },
      { name: "Green Accent-4", value: "#00C853" },
      { name: "Light Green Lighten-5", value: "#F1F8E9" },
      { name: "Light Green Lighten-4", value: "#DCEDC8" },
      { name: "Light Green Lighten-3", value: "#C5E1A5" },
      { name: "Light Green Lighten-2", value: "#AED581" },
      { name: "Light Green Lighten-1", value: "#9CCC65" },
      { name: "Light Green Darken-1", value: "#7CB342" },
      { name: "Light Green Darken-2", value: "#689F38" },
      { name: "Light Green Darken-3", value: "#558B2F" },
      { name: "Light Green Darken-4", value: "#33691E" },
      { name: "Light Green Accent-1", value: "#CCFF90" },
      { name: "Light Green Accent-2", value: "#B2FF59" },
      { name: "Light Green Accent-3", value: "#76FF03" },
      { name: "Light Green Accent-4", value: "#64DD17" },
      { name: "Lime Lighten-5", value: "#F9FBE7" },
      { name: "Lime Lighten-4", value: "#F0F4C3" },
      { name: "Lime Lighten-3", value: "#E6EE9C" },
      { name: "Lime Lighten-2", value: "#DCE775" },
      { name: "Lime Lighten-1", value: "#D4E157" },
      { name: "Lime Darken-1", value: "#C0CA33" },
      { name: "Lime Darken-2", value: "#AFB42B" },
      { name: "Lime Darken-3", value: "#9E9D24" },
      { name: "Lime Darken-4", value: "#827717" },
      { name: "Lime Accent-1", value: "#F4FF81" },
      { name: "Lime Accent-2", value: "#EEFF41" },
      { name: "Lime Accent-3", value: "#C6FF00" },
      { name: "Lime Accent-4", value: "#AEEA00" },
      { name: "Yellow Lighten-5", value: "#FFFDE7" },
      { name: "Yellow Lighten-4", value: "#FFF9C4" },
      { name: "Yellow Lighten-3", value: "#FFF59D" },
      { name: "Yellow Lighten-2", value: "#FFF176" },
      { name: "Yellow Lighten-1", value: "#FFEE58" },
      { name: "Yellow Darken-1", value: "#FDD835" },
      { name: "Yellow Darken-2", value: "#FBC02D" },
      { name: "Yellow Darken-3", value: "#F9A825" },
      { name: "Yellow Darken-4", value: "#F57F17" },
      { name: "Yellow Accent-1", value: "#FFFF8D" },
      { name: "Yellow Accent-2", value: "#FFFF00" },
      { name: "Yellow Accent-3", value: "#FFEA00" },
      { name: "Yellow Accent-4", value: "#FFD600" },
      { name: "Amber Lighten-5", value: "#FFF8E1" },
      { name: "Amber Lighten-4", value: "#FFECB3" },
      { name: "Amber Lighten-3", value: "#FFE082" },
      { name: "Amber Lighten-2", value: "#FFD54F" },
      { name: "Amber Lighten-1", value: "#FFCA28" },
      { name: "Amber Darken-1", value: "#FFB300" },
      { name: "Amber Darken-2", value: "#FFA000" },
      { name: "Amber Darken-3", value: "#FF8F00" },
      { name: "Amber Darken-4", value: "#FF6F00" },
      { name: "Amber Accent-1", value: "#FFE57F" },
      { name: "Amber Accent-2", value: "#FFD740" },
      { name: "Amber Accent-3", value: "#FFC400" },
      { name: "Amber Accent-4", value: "#FFAB00" },
      { name: "Orange Lighten-5", value: "#FFF3E0" },
      { name: "Orange Lighten-4", value: "#FFE0B2" },
      { name: "Orange Lighten-3", value: "#FFCC80" },
      { name: "Orange Lighten-2", value: "#FFB74D" },
      { name: "Orange Lighten-1", value: "#FFA726" },
      { name: "Orange Darken-1", value: "#FB8C00" },
      { name: "Orange Darken-2", value: "#F57C00" },
      { name: "Orange Darken-3", value: "#EF6C00" },
      { name: "Orange Darken-4", value: "#E65100" },
      { name: "Orange Accent-1", value: "#FFD180" },
      { name: "Orange Accent-2", value: "#FFAB40" },
      { name: "Orange Accent-3", value: "#FF9100" },
      { name: "Orange Accent-4", value: "#FF6D00" },
      { name: "Deep Orange Lighten-5", value: "#FBE9E7" },
      { name: "Deep Orange Lighten-4", value: "#FFCCBC" },
      { name: "Deep Orange Lighten-3", value: "#FFAB91" },
      { name: "Deep Orange Lighten-2", value: "#FF8A65" },
      { name: "Deep Orange Lighten-1", value: "#FF7043" },
      { name: "Deep Orange Darken-1", value: "#F4511E" },
      { name: "Deep Orange Darken-2", value: "#E64A19" },
      { name: "Deep Orange Darken-3", value: "#D84315" },
      { name: "Deep Orange Darken-4", value: "#BF360C" },
      { name: "Deep Orange Accent-1", value: "#FF9E80" },
      { name: "Deep Orange Accent-2", value: "#FF6E40" },
      { name: "Deep Orange Accent-3", value: "#FF3D00" },
      { name: "Deep Orange Accent-4", value: "#DD2C00" },
      { name: "Brown Lighten-5", value: "#EFEBE9" },
      { name: "Brown Lighten-4", value: "#D7CCC8" },
      { name: "Brown Lighten-3", value: "#BCAAA4" },
      { name: "Brown Lighten-2", value: "#A1887F" },
      { name: "Brown Lighten-1", value: "#8D6E63" },
      { name: "Brown Darken-1", value: "#6D4C41" },
      { name: "Brown Darken-2", value: "#5D4037" },
      { name: "Brown Darken-3", value: "#4E342E" },
      { name: "Brown Darken-4", value: "#3E2723" },
      { name: "Blue Grey Lighten-5", value: "#ECEFF1" },
      { name: "Blue Grey Lighten-4", value: "#CFD8DC" },
      { name: "Blue Grey Lighten-3", value: "#B0BEC5" },
      { name: "Blue Grey Lighten-2", value: "#90A4AE" },
      { name: "Blue Grey Lighten-1", value: "#78909C" },
      { name: "Blue Grey Darken-1", value: "#546E7A" },
      { name: "Blue Grey Darken-2", value: "#455A64" },
      { name: "Blue Grey Darken-3", value: "#37474F" },
      { name: "Blue Grey Darken-4", value: "#263238" },
      { name: "Grey Lighten-5", value: "#FAFAFA" },
      { name: "Grey Lighten-4", value: "#F5F5F5" },
      { name: "Grey Lighten-3", value: "#EEEEEE" },
      { name: "Grey Lighten-2", value: "#E0E0E0" },
      { name: "Grey Lighten-1", value: "#BDBDBD" },
      { name: "Grey Darken-1", value: "#757575" },
      { name: "Grey Darken-2", value: "#616161" },
      { name: "Grey Darken-3", value: "#424242" },
      { name: "Grey Darken-4", value: "#212121" },
        
        ],
      imageUrl: '',      
      formValid: false,    
      isMobile: false,        
      rules: {
        required: (value) => !!value || "Campo obrigatório.",
      },
    };
  },
  computed: {
    ...mapState(["restaurant"]),
  },
  mounted() {       
    this.checkIsMobile(); 
    window.addEventListener("resize", this.checkIsMobile); 
    this.loadRestaurantData();
    
      if (this.restaurant.photo || this.restaurant.tag_photo) {
      this.imageUrl = this.restaurant.photo || this.restaurant.tag_photo;
    } else {
      this.imageUrl = this.restaurant.photo
      ? `${process.env.VUE_APP_API}/static/restaurant/${this.restaurant.photo}`
      : require('../assets/photo_white.png');
    }             
      this.form.email = this.restaurant.default_email || this.user.email
       
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkIsMobile); // Remove listener ao destruir o componente
  },
  methods: {
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768; 
    },
    getImageSrc() {
      // Se há uma nova foto selecionada pelo usuário
      if (this.photo) {
        return URL.createObjectURL(this.photo); // Gera uma URL temporária para o arquivo
      }    
      if (this.restaurant.photo) {
        return `https://api.socialplace.com.br/${this.restaurant.photo}`;
      }    
      return require('../assets/photo_white.png');  
    },
    loadRestaurantData() {      
      this.form = { ...this.restaurant };
    },
    pickFile() {
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = "image/jpeg, image/jpg";
      fileInput.addEventListener("change", this.onFilePicked);
      fileInput.click();
    },
    onFilePicked(event) {
      const files = event.target.files;
      if (files && files[0]) {
        const file = files[0];

        // Verifica se é um arquivo de imagem válido
        if (!file.name.match(/\.(jpg|jpeg)$/i)) {
          this.$toasted.show("Formato inválido. Use apenas JPG ou JPEG.", {
            type: "error",
          });
          return;
        }        
        if (file.size > 500 * 1024) {
          this.$toasted.show("Tamanho máximo permitido: 500KB.", {
            type: "error",
          });
          return;
        }
        // Lê o arquivo para visualização
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.imageUrl = reader.result; 
          this.photo = file;            
        };
      }
    },
    clearImage() {
      this.imageUrl = "";
      this.photo = null;
    },
  
    async saveChanges() {
      try {
        
        let finalPhoto = this.imageUrl; 

        if (this.photo) {
          const payload = {
            photo: this.photo,
            restaurant_id: this.restaurant._id, 
          };

          const response = await this.$store.dispatch("appendPhoto", payload);          
          finalPhoto = `/static/restaurant/${response._id}.jpg`;          
          this.$toasted.show("Imagem enviada com sucesso!", { type: "success" });
        }
        
        await this.$store.dispatch("updateRestaurant", {
          ...this.form,
          photo: finalPhoto,
          webapp_color_0: this.form.webapp_color_0,
        });
        this.$toasted.show("Dados atualizados com sucesso!", {
          type: "success",
        });
        this.$router.push("/"); 
      } catch (error) {
        console.error("Erro :", error);
        this.$toasted.show("Erro ao salvar os dados. Tente novamente.", {
          type: "error",
        });
      }
    },
    removePhoto() {      
      this.restaurant.tag_photo = null
      this.restaurant.photo = null
      this.$toasted.show("Foto removida com sucesso!", { type: "info" });
    },
    goBack() {
      this.$router.go(-1); 
    },
  },
};
</script>
